import { Size, Token, } from "../../../core";
export class PoleToken extends Token {
    constructor(id, position, color) {
        super(id, position, PoleToken.size);
        this.color = color;
    }
    static isReadonlyInstance(token) {
        return token instanceof PoleToken;
    }
}
PoleToken.size = new Size(0.4, 1.5);
export function getPoleTokenFactory(color) {
    return (id, position) => {
        return new PoleToken(id, position, color);
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9sZS10b2tlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zcG9ydHMvY29tbW9uL2RyaWxsL3BvbGUtdG9rZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUlMLElBQUksRUFDSixLQUFLLEdBRU4sTUFBTSxlQUFlLENBQUM7QUFFdkIsTUFBTSxPQUFPLFNBQVUsU0FBUSxLQUFLO0lBQ2xDLFlBQVksRUFBVSxFQUFFLFFBQWtCLEVBQUUsS0FBWTtRQUN0RCxLQUFLLENBQUMsRUFBRSxFQUFFLFFBQVEsRUFBRSxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDcEMsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7SUFDckIsQ0FBQztJQU1ELE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQyxLQUFvQjtRQUM1QyxPQUFPLEtBQUssWUFBWSxTQUFTLENBQUM7SUFDcEMsQ0FBQzs7QUFKZSxjQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0FBVzVDLE1BQU0sVUFBVSxtQkFBbUIsQ0FBQyxLQUFZO0lBQzlDLE9BQU8sQ0FBQyxFQUFVLEVBQUUsUUFBa0IsRUFBRSxFQUFFO1FBQ3hDLE9BQU8sSUFBSSxTQUFTLENBQUMsRUFBRSxFQUFFLFFBQVEsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM1QyxDQUFDLENBQUM7QUFDSixDQUFDIn0=